import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Phone } from '../../../../../interfaces/Advisors';
import Section from '../../../../../components/Section';
import Content2 from '../../../ContactInformation/Content';
import { StyledTelLink } from '../Content.styles';

export interface PhonesProps {
  phones: Phone;
}

const Phones: FC<PhonesProps> = ({ phones }) => {
  const { t } = useTranslation('ContactUsPage');

  const phonesElements: JSX.Element[] = [];
  const rejected = ['', null, undefined];

  if (!rejected.includes(phones?.local)) {
    phonesElements.push(
      <>
        {t('telephoneLocal')} <StyledTelLink phone={`tel:${phones.local}`}>{phones.local}</StyledTelLink>
      </>,
    );
  }

  if (!rejected.includes(phones?.tollFree)) {
    phonesElements.push(
      <>
        {t('tollFree')} <StyledTelLink phone={`tel:${phones.tollFree}`}>{`${phones.tollFree}`}</StyledTelLink>
      </>,
    );
  }

  if (phonesElements.length === 0) {
    return null;
  }

  return (
    <Section name={t('telephone')}>
      <Content2 lines={phonesElements} />
    </Section>
  );
};

export default Phones;
